import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Divider, Grid, List } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';
import {
    HarvestEventGroupId,
    HarvestEventsProps
} from 'services/harvestEvents/types';

// Global Components
import GroupName from 'components/GroupName';
import SemiBold from 'components/SemiBold';

// Global Selectors
import { makeSelectHarvestEventGroupIds } from 'services/harvestEvents/selectors';

interface OwnProps extends HarvestEventsProps {
    withDivider?: boolean;
}

interface ConnectedProps {
    groupIds?: HarvestEventGroupId[];
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventAssignedGroupsListComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { groupIds, withDivider } = this.props;
        if (!groupIds || !groupIds.length) {
            return null;
        }
        return (
            <div>
                <Grid>
                    <Grid.Column width={16}>
                        <SemiBold>Assigned Groups</SemiBold>
                    </Grid.Column>
                    <Grid.Column width={16}>
                        <List>
                            {groupIds.map(groupId => (
                                <List.Item key={groupId}>
                                    <List.Content>
                                        <GroupName groupId={groupId} />
                                    </List.Content>
                                </List.Item>
                            ))}
                        </List>
                    </Grid.Column>
                </Grid>
                {withDivider && <Divider section />}
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    groupIds: makeSelectHarvestEventGroupIds()
});

export default connect(mapStateToProps)(
    HarvestEventAssignedGroupsListComponent
);
